import { useAuth, useOrganizationList } from '@clerk/clerk-react';
import { useLayoutEffect } from 'react';
import { useNavigate } from 'react-router';

export function HomePage() {
  const { isLoaded, orgSlug } = useAuth();
  const navigate = useNavigate();

  // get all organizations, select first one if there's no active org related to the user
  const {
    isLoaded: isOrgListLoaded,
    setActive,
    userMemberships
  } = useOrganizationList({
    userMemberships: {
      infinite: true
    }
  });

  const isFetching = userMemberships.isFetching;

  useLayoutEffect(() => {
    if (isLoaded && isOrgListLoaded && !isFetching) {
      if (!orgSlug) {
        const found = userMemberships.data.length > 0;
        if (found) {
          setActive({ organization: userMemberships.data[0].id })
            .then(() => {
              void navigate(`/merchants/${userMemberships.data[0].organization.slug!}/dashboard`);
            })
            .catch((e: unknown) => {
              console.error('cannot set active org', e);
            });
        } else {
          void navigate('/getting-started');
        }
      } else {
        void navigate(`/merchants/${orgSlug}/dashboard`);
      }
    }
  }, [isLoaded, isOrgListLoaded, isFetching, setActive, userMemberships, navigate, orgSlug]);

  return null;
}
